import { BitrixVue } from 'ui.vue';

import '../../../swiper/Swiper.js';
import '../../../slider/simpleItem.js';

BitrixVue.cloneComponent('Step2', 'Steps', {
	data() {
		return {
			step2: null,
			selectedGlazing: 0,
			selectedColor: 0,
			selectedGlass: 0,
		};
	},
	props: ['doorCover', 'door'],
	created() {
		this.getDataStep();
	},
	methods: {
		isDataStep: function () {
			return this.step2;
		},
		getDataStep: function () {
			let context = this;
			let store = { ...this.$store.state.position };
			delete store.renderImage;
			let req = BX.ajax.runComponentAction('mworks:configurator', 'getDataStep2', {
				mode: 'class',
				method: 'post',
				data: {
					position: store,
				},
			});

			req.catch(function (response) {
			});

			req.then((response) => {
				if (response.status == 'success') {
					context.step2 = response.data.result;
					context.selectedGlazing = 0;

					context.setPropPosition({
						glazingType: this.step2.glazing[context.selectedGlazing],
					});

					if (context.step2.glazing[context.selectedGlazing].title.toLowerCase() !== 'глухое' && context.step2.colors !== null) {
						context.selectedColor = 0;
						context.selectedGlass = 0;
						context.setPropPosition({
							glazingType: this.step2.glazing[context.selectedGlazing],
							glazingColor: this.step2.colors[context.selectedColor],
							glazingGlass: this.step2.colors[context.selectedColor]?.glass[this.selectedGlass],
						});
					}
				}
			});
		},

		showGlassBlock(index) {
			this.selectedGlazing = index;
			if (index !== 0) {
				this.selectedColor = 0;
				this.selectedGlass = 0;

				if (this.isColorExist()) {
					this.setPropPosition({ glazingColor: this.step2.colors[this.selectedColor] });
				}

				if (this.isGlassExist()) {
					this.setPropPosition({
						glazingGlass: this.step2.colors[this.selectedColor]?.glass[this.selectedGlass],
					});
				}
			}
		},
		isColorExist() {
			return this.step2.glazing[this.selectedGlazing].title.trim().toLowerCase() !== 'глухое' && typeof this.step2.colors[this.selectedColor] !== undefined ? true : false;
			// return this.selectedGlazing !== null && this.selectedGlazing !== 0;
		},
		isGlassExist() {
			return this.step2.glazing[this.selectedGlazing].title.trim().toLowerCase() !== 'глухое' &&
				typeof this.step2.colors[this.selectedColor].glass[this.selectedGlass] !== undefined
				? true
				: false;
			// return this.selectedGlazing !== null && this.selectedGlazing !== 0 && this.selectedColor !== null;
		},
	},
	watch: {
		selectedGlazing: function (val) {
			if (val !== undefined && val !== null) {
				if (val === 0) {
					this.setPropPosition({
						glazingType: this.step2.glazing[val],
						glazingColor: null,
						glazingGlass: null,
					});
				} else {
					this.setPropPosition({ glazingType: this.step2.glazing[val] });
				}
			} else {
				this.setPropPosition({
					glazingType: null,
					glazingColor: null,
					glazingGlass: null,
				});
			}
		},
		selectedColor: function (val, oldVal) {
			if (this.step2.colors[val].glass !== undefined) {
				this.selectedGlass = 0;
				this.setPropPosition({
					glazingGlass: this.step2.colors[val].glass[this.selectedGlass],
				});
			}

			// if (oldVal !== val) {
			// 	this.selectedGlass = 0;
			// 	this.setPropPosition({ glazingGlass: null });
			// }

			if (val !== undefined && val !== null) {
				this.setPropPosition({ glazingColor: this.step2.colors[val] });
			} else {
				this.setPropPosition({ glazingColor: null });
			}
		},
		selectedGlass: function (val) {
			if (val !== null) {
				this.setPropPosition({
					glazingGlass: this.step2.colors[this.selectedColor]?.glass[val],
				});
			} else {
				this.setPropPosition({ glazingGlass: null });
			}
		},

		door(val) {
			if (val !== undefined && val !== null) {
				if (this.doorCover === undefined || this.doorCover === null) {
					this.getDataStep();
				}
			}
		},
		doorCover(val, oldValue) {
			if (val !== undefined && val !== null && oldValue !== null) {
				if (val.title !== oldValue.title) {
					this.getDataStep();
				}
			}
		},
	},
	template: `
	<div class="config-block">
		<div class="config-block__inner" v-if="isDataStep()">
			<div class="config-block__wrap">
				<div class="config-block__wrap-title">Тип полотна</div>
				<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="2">
					<div class="swiper-slide" v-for="(slide, index) of step2.glazing">
						<SimpleItemTop
							:image="slide.image"
							:title="slide.title"
							:key="slide.id"
							:class="{active: selectedGlazing === index}"
							v-on:setActive="showGlassBlock(index)"
							/>
					</div>
				</Swiper>
			</div>
			<div class="config-block__wrap mt-48" v-if="isColorExist()">
				<div class="config-block__wrap-title">Цвет стекла</div>
				<div class="flex config-row__colors">
					<Color v-for="(color, index) of step2.colors" :class="{active: selectedColor === index}"
						:color="color" :key="color.id" v-on:setActiveColor="selectedColor = index" />
				</div>
			</div>
			<div class="config-block__wrap mt-48" v-if="isGlassExist()">
				<div class="config-block__wrap-title">Рисунок стекла</div>
				<Swiper :basicSlidesPerView="3" :basicSpaceBetween="20" :breakpointsForSlides="6" class="glazing-slider">
					<div class="swiper-slide" v-for="(slide, index) of step2.colors[selectedColor].glass">
						<SimpleItem :image="slide.image" :price="slide.price" :priceType="2" :key="slide.id"
							:class="{active: selectedGlass === index}" v-on:setActive="selectedGlass = index" />
					</div>
				</Swiper>
			</div>
		</div>
		<div v-else>
			<div class="config-block__wrap">
				<div class="config-block__wrap-title">Тип полотна</div>
				<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="2">
					<div class="swiper-slide" v-for="slide of [1,2]">
						<PuSkeleton height="200px" />
					</div>
				</Swiper>
			</div>
		</div>
	</div>
`,
});
